import DetailProvider from '@components/Review/Detail';
import React from 'react';

export default (props) => <DetailProvider {...props} hasReview={false} />;
